import React, { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Flex, Image, Tooltip, Upload } from "antd";
import { Button, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const UploadInput = (props) => {
  const {
    value = [],
    maxCount = 1,
    hideUpload = false,
    onDelete,
    ...restProps
  } = props;
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);

  const handlePreview = async (file) => {
    if (!file.thumbUrl && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreviewImage(file.thumbUrl || file.preview);
    setPreviewOpen(true);
  };

  useEffect(() => {
    const imgsWithtId = value?.filter((image) => !!image.id) || [];
    setFileList((prev) => {
      const newFileList = [...prev];
      if (imgsWithtId?.length > 0) {
        newFileList.splice(0, imgsWithtId?.length);
      }
      return newFileList;
    });
  }, [value]);

  const handleChange = (info) => {
    setFileList(info.fileList);
    const newState = info.fileList.map((file) => file.originFileObj);
    const oldState = value?.filter((image) => !!image.id) || [];
    props?.onChange?.(newState, info);
  };

  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  const showUpload = !(value.filter((image) => image?.id).length >= maxCount);

  return (
    <>
      {showUpload && !hideUpload && (
        <Upload
          accept="image/*"
          beforeUpload={() => false}
          {...restProps}
          listType="picture-card"
          fileList={fileList}
          onPreview={handlePreview}
          onChange={handleChange}
          onRemove={(...args) => {
            console.log("remove: ", args);
          }}
          maxCount={maxCount}
        >
          {fileList.length >= maxCount ? null : uploadButton}
        </Upload>
      )}

      <div>
        <Flex
          className="inline-flex"
          align="center"
          justify="center"
          gap={8}
          wrap
        >
          {value?.map((image) => {
            if (!image.id) {
              return null;
            }
            return (
              <Stack key={image.id}>
                <div>
                  <Image
                    style={{
                      width: "100px",
                      height: "100px",
                      borderRadius: "8px",
                      overflow: "hidden",
                    }}
                    preview={{
                      open: previewOpen,
                      onVisibleChange: (visible) => setPreviewOpen(visible),
                      afterOpenChange: (visible) =>
                        !visible && setPreviewImage(""),
                    }}
                    src={image.url}
                  />
                </div>
                {/* <div>
                  <Tooltip title={t("DELETE")}>
                    <button
                      disabled={props.disabled}
                      className="btn btn-danger btn-sm"
                      type="button"
                      onClick={() => {
                        onDelete?.(image);
                      }}
                    >
                      {t("DELETE")}
                    </button>
                  </Tooltip>
                </div> */}
              </Stack>
            );
          })}
        </Flex>
      </div>

      {previewImage && (
        <Image
          style={{
            display: "none",
          }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )}
    </>
  );
};
